import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import { CircularProgress, Backdrop, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const VehicleGuard = ({ children, ...rest }) => {
  const classes = useStyles();
  const token = localStorage.getItem("token:data");
  const { profile } = useSelector((state) => state.users);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Wait a moment for profile to load if token exists
    if (token && profile) {
      setChecking(false);
    } else if (!token) {
      setChecking(false);
    } else {
      // Token exists but no profile yet, keep checking
      const timer = setTimeout(() => {
        setChecking(false);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [token, profile]);

  if (checking) {
    return (
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  const hasVehiclePermission = () => {
    if (!profile || !profile.role) return false;
    
    return profile.role.some((role) => 
      ["admin", "vehicle_admin", "vehicle_manager", "vehicle_supervisor"].includes(role.name)
    );
  };

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!token) {
          return <Redirect to={{ pathname: "/", state: { from: location } }} />;
        }

        if (!profile) {
          return (
            <Backdrop className={classes.backdrop} open={true}>
              <CircularProgress color="inherit" />
            </Backdrop>
          );
        }
        return children;

        // if (hasVehiclePermission()) {
        //   return children;
        // }

        // return <Redirect to={{ pathname: "/dashboard", state: { from: location } }} />;
      }}
    />
  );
};

export default VehicleGuard;